import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const TripStatsIcon = (props) => (
  <SvgIcon viewBox="0 0 36 36" {...props}>
    <path
      d="M28.5 6C26.8425 6 25.5 7.3425 25.5 9V27C25.5 28.6575 26.8425 30 28.5 30H31.5C33.1575 30 34.5 28.6575 34.5 27V9C34.5 7.3425 33.1575 6 31.5 6H28.5ZM16.5 12C14.8425 12 13.5 13.3425 13.5 15V27C13.5 28.6575 14.8425 30 16.5 30H19.5C21.1575 30 22.5 28.6575 22.5 27V15C22.5 13.3425 21.1575 12 19.5 12H16.5ZM4.5 18C2.8425 18 1.5 19.3425 1.5 21V27C1.5 28.6575 2.8425 30 4.5 30H7.5C9.1575 30 10.5 28.6575 10.5 27V21C10.5 19.3425 9.1575 18 7.5 18H4.5Z"
      fill={props.sx?.color || '#9C9FA5'}
    />
  </SvgIcon>
);

TripStatsIcon.propTypes = {
  sx: PropTypes.object,
};

export default TripStatsIcon;
